import { MEMBER, MEMBER_TOKEN } from "@src/mock/data/member";

export default {
  title: '登入',
  type: 'post',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": {
          "body": {
            token: MEMBER_TOKEN,
            ...MEMBER
          },
        }
      }
    }
  ]
}

